export namespace ScreenUrl {
    export const TOP = '/';
    export namespace Auth {
        export const LOGIN = '/login';
        export const PASSWORD_CHANGE = '/password_change';
        export const SAML_OA = '/api/saml/oa';
        export const SAML_OAFB = '/api/saml/oafb';
        export const SAML_VERIFY = '/api/saml/verify';
        export const NODE_SAML_LOGIN = '/api/node_samls/sp/acs/';
    }
    export namespace Dashboard {
        export const INDEX = '/dashboard';
    }
    export namespace User {
        export const INDEX = '/users';
        export const SHOW = `${INDEX}/:id`;
        export const ACCESS_KEYS = `${SHOW}/access_keys`;
    }
    export namespace UserGroup {
        export const INDEX = '/user_groups';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace NodeDomain {
        export const INDEX = '/node_domains';
        export const SHOW = `${INDEX}/:id`;
        export const CSV_OUTPUT = `${INDEX}/csv`;
        export namespace Account {
            const INDEX1 = `${INDEX}/:domain_id/accounts`;
            export const DIRECT_SEARCH = `${INDEX1}`;
            export const SHOW = `${INDEX1}/:account_id`;
        }
    }
    export namespace NodeIdp {
        export const INDEX = '/node_idps';
        export const SHOW = `${INDEX}/:id`;
        export const CSV_OUTPUT = `${INDEX}/csv`;
        export namespace Account {
            const INDEX1 = `${INDEX}/:idp_id/accounts`;
            export const DIRECT_SEARCH = `${INDEX1}`;
            export const SHOW = `${INDEX1}/:account_id`;
        }
    }
    export namespace Node {
        export const INDEX = '/nodes';
        export const SHOW = `${INDEX}/:id`;
        export namespace OsAccount {
            const INDEX1 = `${INDEX}/:node_id/os_accounts`;
            export const DIRECT_SEARCH = `${INDEX1}`;
            export const SHOW = `${INDEX1}/:account_id`;
        }
        export namespace OtherAccount {
            const INDEX1 = `${INDEX}/:node_id/other_accounts`;
            export const DIRECT_SEARCH = `${INDEX1}`;
            export const SHOW = `${INDEX1}/:account_id`;
        }
        export namespace AutoLoginApp {
            const INDEX1 = `${INDEX}/:node_id/auto_login_apps`;
            export const DIRECT_SEARCH = `${INDEX1}`;
            export const SHOW = `${INDEX1}/:app_id`;
        }
    }
    export namespace NodeGroup {
        export const INDEX = '/node_groups';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace SysPre {
        const INDEX = '/sys_pre';
        export namespace Server {
            export const SHOW = `${INDEX}/servers`;
        }
        export namespace UserDomain {
            export const SHOW = `${INDEX}/user_domains`;
        }
        export namespace Mail {
            export const SHOW = `${INDEX}/mails`;
        }
    }
    export namespace MultifactorAuth {
        export const INDEX = '/multifactor_authentications';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace SystemChangeHistory {
        export const INDEX = '/system_change_histories';
    }
    export namespace JobExecutionHistory {
        export const INDEX = '/job_execution_histories';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace Csv {
        export const INDEX = '/csv';
    }
    export namespace DetectionRule {
        export const INDEX = '/detection_rules';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace DetectionRuleGroup {
        export const INDEX = '/detection_rule_groups';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace Workflow {
        export const INDEX = '/workflows';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace BusinessSystem {
        export const INDEX = '/business_systems';
        export const SHOW = `${INDEX}/:id`;
        export namespace ApplicationTemplate {
            const INDEX1 = `${INDEX}/:id/application_templates`;
            export const SHOW = `${INDEX1}/:application_template_id`;
            export const DIRECT_SEARCH = `${INDEX1}`;
        }
        export namespace AccountSet {
            const INDEX1 = `${INDEX}/:business_system_id/account_sets`;
            export const SHOW = `${INDEX1}/:id`;
            export const DIRECT_SEARCH = `${INDEX1}`;
        }
        export namespace RoutineWorkTemplate {
            const INDEX1 = `${INDEX}/:id/routine_works_templates`;
            export const SHOW = `${INDEX1}/:routine_work_template_id`;
            export const DIRECT_SEARCH = `${INDEX1}`;
        }
    }
    export namespace AutoLoginApp {
        export const INDEX = '/auto_login_applications';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace ApplicationFormTemplate {
        export const INDEX = '/application_form_templates';
        export namespace ApplicationForm {
            const INDEX1 = `${INDEX}/:template_id/application_form`;
            export const CREATE_SIMPLE = `${INDEX1}/simple`;
            export const CREATE_DETAILS = `${INDEX1}/details`;
        }
        export const COPY = `${INDEX}/application_form/:id/details`;
    }
    export namespace ApplicationForm {
        export const INDEX = '/application_forms';
        export const SHOW = '/application_forms/:id';
        export namespace LendingRecord {
            export const INDEX1 = `${INDEX}/:application_form_id/lending_records`;
        }
        export namespace DetectionRulesRecords {
            const INDEX1 = `${INDEX}/:id/detection_rules_records`;
            export const DIRECT_SEARCH = `${INDEX1}`;
        }
    }
    export namespace WaitingApplication {
        export const INDEX = '/waiting_applications';
        export const CREATE_DETAILS = `${INDEX}/:id`;
    }
    export namespace PrivilegedIdSetting {
        export const SHOW = `/privileged_id_setting`;
    }
    export namespace privilegeIdLendingRecord {
        export const INDEX = '/privilege_id_lending_records';
        export const SHOW = '/privilege_id_lending_records/:id';
    }
    export namespace DetectionRulesRecord {
        export const INDEX = '/detection_rules_record';
        export const SHOW = '/detection_rules_record/:id';
    }
    export namespace LoginRecord {
        export const INDEX = '/login_records';
    }
    export namespace PersonalSetting {
        export const INDEX = '/personal_settings';
    }
    export namespace AlertSetting {
        export const INDEX = '/alert_settings';
    }
    export namespace RecLinkageSetting {
        export const INDEX = '/rec_linkage_settings';
    }
    export namespace License {
        export const INDEX = '/licenses';
        export const SHOW = '/licenses/:id';
    }
    export namespace ExternalProgramUsage {
        export const INDEX = '/external_program_usage';
        export const SHOW = '/external_program_usage/:id';
    }
    export namespace LoginFailureRecord {
        export const INDEX = '/login_failure_records';
    }
    export namespace NodeLoginHistoryExcludeCondition {
        export const INDEX = '/node_login_history_exclude_conditions';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace AccountInventoryResultDiff {
        export const INDEX = `/account_inventory_result_diffs`;
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace AccountInventorySetting {
        export const INDEX = '/account_inventory_settings';
        export const SHOW = `${INDEX}/:id`;
    }
    export namespace AccountInventoryResult {
        export const INDEX = `/account_inventory_results`;
        export const SHOW = `${INDEX}/:id`;
        export const NODE_ITEMS = `${INDEX}/:id/node_items`;
        export const DOMAIN_ITEMS = `${INDEX}/:id/domain_items`;
        export const CSV_OUTPUT = `${INDEX}/:id/items/csv`;
    }
    export namespace NodeSaml {
        export const INDEX = '/node_samls';
        export const BEFORE = `${INDEX}/before`;
        export const ERROR = `${INDEX}/error`;
    }
}

export default ScreenUrl;
